import { createContext, useCallback, useContext, useState } from "react";

const SettingContext = createContext<any>(null);

export const SettingProvider = ({ children }: any) => {
  const [titleHeader, setTitleHeader] = useState<string>("");
  const [routeTitleHeader, setRouteTitleHeader] = useState<string>("");

  const updateTitleHeader = useCallback((title: string) => {
    setTitleHeader(title);
  }, []);

  const updateRouteTitleHeader = useCallback((title: string) => {
    setRouteTitleHeader(title);
  }, []);

  const clearRouteTitleHeader = useCallback(() => {
    setRouteTitleHeader("");
  }, []);

  return (
    <SettingContext.Provider
      value={{
        titleHeader,
        routeTitleHeader,
        updateTitleHeader,
        updateRouteTitleHeader,
        clearRouteTitleHeader,
      }}
    >
      {children}
    </SettingContext.Provider>
  );
};

export const useSetting = () => {
  return useContext(SettingContext);
};
